import { endpoints } from "./Config";

const baseURL = endpoints.baseURL;
export const LOGIN = `${baseURL}${endpoints.auth.Login}`;
export const CHANGEPASSWORD = `${baseURL}${endpoints.auth.ChangePassWord}`;
export const FORGOTPASSWORD = `${baseURL}${endpoints.auth.ForgotPassword}`;
export const RESETPASSWORD = `${baseURL}${endpoints.auth.ResetPassword}`;
export const GETALLPRODUCTS = `${baseURL}${endpoints.products.GETALLPRODUCTS}`;
export const ADDNEWPRODUCT = `${baseURL}${endpoints.products.ADDNEWPRODUCT}`;
export const DELETEPRODUCT = `${baseURL}${endpoints.products.DELETEPRODUCT}`;
export const UPDATEPRODUCT = `${baseURL}${endpoints.products.UPDATEPRODUCT}`;
export const GETPRICECOMPARISONDATA = `${baseURL}${endpoints.topDeals.GetComparisonData}`;
export const ACCEPTPRODUCTPRICE = `${baseURL}${endpoints.topDeals.AcceptProductPrice}`;
export const USERINTEGRATIONS = `${baseURL}${endpoints.topDeals.UserIntegrations}`;
export const GETPAYMENTREPORT = `${baseURL}${endpoints.payment.GetPaymentReport}`;
export const GETPAYMENTREPORTCONDENSED = `${baseURL}${endpoints.payment.GetPaymentReportCondensed}`;
export const DOWNLOADPAYMENTREPORT = `${baseURL}${endpoints.payment.DownloadPaymentReport}`;
export const GETCATEGORIESLIST = `${baseURL}${endpoints.productCategories.GetCategoriesList}`;
export const GETCATEGORYFIELDS = `${baseURL}${endpoints.productCategories.GetFields}`;
export const GETCOMPARISONLIST = `${baseURL}${endpoints.products.ComparisonList}`;
export const DOWNLOADCOMPARISONDATA = `${baseURL}${endpoints.products.DownloadComparisonData}`;
export const GETFIELDSBYCATEGORYNAME = `${baseURL}${endpoints.productCategories.GetFieldsByCategoryName}`;
export const DUPLICATEPRODUCT = `${baseURL}${endpoints.products.DUPLICATEPRODUCT}`;
export const UPDATE_CATEGORY = `${baseURL}${endpoints.productCategories.UPDATECATEGORY}`;
export const UPLOAD_PRODUCTS = `${baseURL}${endpoints.products.UPLOAD_PRODUCTS}`;
export const UPLOAD_VENDORFORMAT_CSV = `${baseURL}${endpoints.products.UPLOAD_VENDORFORMAT_CSV}`;
export const DOWNLOAD_CSV = `${baseURL}${endpoints.products.DOWNLOAD_CSV}`;
export const DOWNLOAD_SAMPLE_CSV = `${baseURL}${endpoints.products.DOWNLOAD_SAMPLE_CSV}`;
export const GET_PRODUCT_MODEL_LIST = `${baseURL}${endpoints.productModels.GetProductModelList}`;
export const GET_PRODUCT_WEIGHT_LIST = `${baseURL}${endpoints.productWeights.GetProductWeightList}`;
export const GET_PRODUCT_GRADE_LIST = `${baseURL}${endpoints.productGrades.GetProductGradeList}`;
export const GET_PRODUCT_DESCRIPTION = `${baseURL}${endpoints.productDescription.GetProductDescription}`;
export const GET_PRODUCT_METAFIELDS = `${baseURL}${endpoints.products.PRODUCT_META_FIELDS}`;
export const ADDCAMPAIGN = `${baseURL}${endpoints.campaign.ADDCAMPAIGN}`;
export const GETCAMPAIGN = `${baseURL}${endpoints.campaign.GETCAMPAIGN}`;
export const UPDATECAMPAIGN = `${baseURL}${endpoints.campaign.UPDATECAMPAIGN}`;
export const GET_OPERATIONAL_ADDRESS = `${baseURL}${endpoints.user.GetOperationalAddress}`;
export const UPDATE_OPERATIONAL_ADDRESS = `${baseURL}${endpoints.user.UpdateOperationalAddress}`;
export const GET_SUGGESTED_STREETS = `${baseURL}${endpoints.user.GetSuggestedStreets}`;
export const GET_POSTALCODEBY_STREET = `${baseURL}${endpoints.user.GetPostalCodeByStreet}`;
export const UPDATEUSER = `${baseURL}${endpoints.admin.UPDATEUSER}`;
export const REGISTER = `${baseURL}${endpoints.admin.REGISTER}`;
export const GETUSERS = `${baseURL}${endpoints.admin.GETUSERS}`;
export const VIEWASUSER = `${baseURL}${endpoints.admin.VIEWASUSER}`;
export const TOGGLE_AUTOACCEPT_ORDERS = `${baseURL}${endpoints.order.ToggleAutoAcceptOrder}`;
export const TOGGLEPRINTINGPREFERENCE = `${baseURL}${endpoints.user.UpdatePrintingPreference}`;
export const UPDATEOPERATIONALHOURS = `${baseURL}${endpoints.user.UpdateOperationalHours}`;
export const GETUSERPREFERENCES = `${baseURL}${endpoints.user.GetUserPreferences}`;

export const AddReply = `${baseURL}${endpoints.summary.AddReply}`;
export const GetVendorReviews = `${baseURL}${endpoints.summary.GetVendorReviews}`;


export const GETSUMMARY = `${baseURL}${endpoints.summary.GETSUMMARY}`;


export const GETHOLIDAYDAYS = `${baseURL}${endpoints.products.GetHolidayDays}`;
export const ADDHOLIDAYDAYS = `${baseURL}${endpoints.products.AddHolidayDays}`;
export const DELETEHOLIDAYDAYS = `${baseURL}${endpoints.products.DeleteHolidayDays}`;
export const UPDATEHOLIDAYDAYS = `${baseURL}${endpoints.products.UpdateHolidayDays}`;

export const PayVendor = `${baseURL}${endpoints.order.PayVendor}`;
export const PayMiscVendor = `${baseURL}${endpoints.order.PayMiscVendor}`;
export const ViewVendorMisc = `${baseURL}${endpoints.order.ViewVendorMisc}`;

export const REGISTERSPORTSSHOP = `${baseURL}${endpoints.SportsShopOnBoarding.Register}`;
export const SPORTSSHOPOTP = `${baseURL}${endpoints.SportsShopOnBoarding.SendOtp}`;
export const SPORTSSHOPVERIFYOTP = `${baseURL}${endpoints.SportsShopOnBoarding.VerifyOtp}`;

export const GENERATEWOOAUTHLINK = `${baseURL}${endpoints.WooCommerce.AuthLink}`;
export const UPDATEWOOPRICEPREFERENCE = `${baseURL}${endpoints.WooCommerce.UpdatePricePreference}`;
export const UPDATECATEGORYMAP = `${baseURL}${endpoints.WooCommerce.UpdateCategoryMap}`;
export const GETWOOCOMMERCEUPLOADSTATUS = `${baseURL}${endpoints.WooCommerce.UploadStatus}`;

export const GENERATESHOPIFYAPPLINK = `${baseURL}${endpoints.Shopify.AppLink}`;
export const GETSHOPIFYUPLOADSTATUS = `${baseURL}${endpoints.Shopify.UploadStatus}`;
export const UPDATESHOPIFYPRICEPREFERENCE = `${baseURL}${endpoints.Shopify.UpdatePricePreference}`;
export const UPDATESHOPIFYCATEGORYMAP = `${baseURL}${endpoints.Shopify.UpdateCategoryMap}`;
export const UPDATESHOPIFYPRODUCTMAP = `${baseURL}${endpoints.Shopify.UpdateProductMap}`;